<template>
  <a-upload-dragger
    :headers="headers"
    :action="url"
    :fileList="fileList"
    @change="handleChange"
    :beforeUpload="beforeUpload"
  >
    <p class="ant-upload-drag-icon">
      <a-icon type="inbox" />
    </p>
    <p class="ant-upload-text">点击图标或将文件拖拽到这里上传</p>
    <p class="ant-upload-hint">
      支持拓展名：.rar .zip .doc .docx .jpg
    </p>
  </a-upload-dragger>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Upload',
  props: {
    url: {
      type: String,
      default: 'api/storage/upload'
    },
    fileListTemp: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fileList: this.fileListTemp,
      headers: {
        'Authorization': 'Bearer' + this.token()
      }
    }
  },
  methods: {
    ...mapGetters(['token']),
    handleChange (info) {
      let fileList = [...info.fileList]
      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      // 负数是从尾部开始截取 限制最长15
      fileList = fileList.slice(-15)
      fileList = fileList.filter(item => item.status !== undefined)

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.data.url
        }
        return file
      })

      this.fileList = fileList
    },
    beforeUpload (file) {
      // 此处针对修改操作时，如果之前没有数据this.fileList时null 进行...this.fileList会报错
      // 错误类型： Invalid attempt to spread non-iterable instance
      if (this.fileList === null) {
        this.fileList = []
      }
      const list = [...this.fileList]
      const listLength = list.length > 14
      if (listLength) {
        this.$message.warning('最多上传15个文件')
      }
      const size = file.size / 1024 / 1024 > 100
      if (size) {
        this.$message.warning('上传文件不能大于100MB')
      }
      return !size && !listLength
    }
  },
  watch: {
    fileList (val) {
      this.fileList = val
      // 向父组件更新
      this.$emit('updateFileList', val)
    },
    fileListTemp (val) {
      this.fileList = val
    }
  }
}
</script>

<style scoped>

</style>
